module.exports = __webpack_public_path__ + "media/images/talent/case-before-694addacfd93c0f70eceba7022da454a.png";